import { render } from "./AllProductinoffer.vue?vue&type=template&id=a27d629a"
import script from "./AllProductinoffer.vue?vue&type=script&lang=js"
export * from "./AllProductinoffer.vue?vue&type=script&lang=js"

import "./AllProductinoffer.vue?vue&type=style&index=0&id=a27d629a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__